/**
 * 今日の進捗ヘッダーコンポーネント
 *
 * ダッシュボード上部に表示される進捗状況のサマリー。
 * 今日の日付、完了率、プログレスバーを表示する。
 *
 * Rails で言えば:
 * - app/views/dashboard/_progress_header.html.erb に相当
 *
 * @example
 * <ProgressHeader
 *   progressPercent={75}
 *   completedCount={3}
 *   totalCount={4}
 * />
 */

interface ProgressHeaderProps {
  /** 達成率（0〜100） */
  progressPercent: number
  /** 完了した習慣の数 */
  completedCount: number
  /** 予定されている習慣の総数 */
  totalCount: number
}

export function ProgressHeader({
  progressPercent,
  completedCount,
  totalCount,
}: ProgressHeaderProps) {
  return (
    <div className="bg-card border-border mb-4 rounded-xl border p-4 sm:mb-6 sm:rounded-2xl sm:p-6">
      {/* ヘッダー: 日付と進捗率 */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-foreground text-lg font-bold sm:text-xl">
            今日の進捗
          </h1>
          <p className="text-muted-foreground text-sm">
            {new Date().toLocaleDateString('ja-JP', {
              month: 'long',
              day: 'numeric',
              weekday: 'short',
            })}
          </p>
        </div>
        <div className="text-right">
          <div className="text-primary text-2xl font-bold sm:text-3xl">
            {progressPercent}%
          </div>
          <div className="text-muted-foreground text-sm">
            {completedCount}/{totalCount} 完了
          </div>
        </div>
      </div>

      {/* プログレスバー: アクセシビリティ対応 */}
      <div
        role="progressbar"
        aria-valuenow={progressPercent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="今日の進捗"
        className="bg-muted h-3 overflow-hidden rounded-full"
      >
        <div
          className="bg-primary h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  )
}
